<template>
    <div v-if="!isTxtMode" class="absolute inset-y-0 flex items-center">
        <div v-if="visible && status == 'C'" class="pointer-events-none">
            <div class="relative flex items-center">
                <span class="z-badge sm light">{{text}}</span>
            </div>
        </div>
        <div v-if="visible && status == 'P'" class="ml-1 pointer-events-none">
            <div class="relative flex items-center">
                <span class="z-badge sm warning">{{text}}</span>
                <span class="animate-ping absolute size-full rounded-full bg-orange-400 opacity-15"></span>
            </div>
        </div>
    </div>
    <div v-else class="inset-y-0 flex items-center" :class="{'md:absolute mt-1':!isSameLine,'absolute':isSameLine}">
        <div v-if="visible && isConfirmedTxt" class="pointer-events-none">
            <div class="relative flex items-center">
                <span class="z-badge sm light">{{cTxt}}</span>
            </div>
        </div>
        <div v-if="visible && isPendingTxt" class="ml-1 pointer-events-none">
            <div class="relative flex items-center">
                <span class="z-badge sm warning">{{pTxt}}</span>
                <span class="animate-ping absolute size-full rounded-full bg-orange-400 opacity-15"></span>
            </div>
        </div>
    </div>
    
</template>

<script>

    export default {
        name: "ping-badge",
        props: ['hide','status', 'cTxt','pTxt'],
        components: {
        },
        data() {
            return {
            }
        },
        computed: {
            text() {
                switch(this.status)
                {
                    case 'E':
                        return '';
                    case 'P':
                        return '인증대기';
                    case 'C':
                        return '인증됨';
                    default:
                        return '';
                }
            },
            isTxtMode() {
                return this.isConfirmedTxt || this.isPendingTxt;
            },
            isConfirmedTxt() {
                return (this.cTxt != '' && this.cTxt != null && this.cTxt != undefined);
            },
            isPendingTxt() {
                return (this.pTxt != '' && this.pTxt != null && this.pTxt != undefined);
            },
            visible() {
                return (this.hide == false || this.hide == "Y" || this.hide == null || this.hide == undefined || this.hide == '');
            },
            isSameLine() {
                var text = this.cTxt + this.pTxt;

                var commaCount = text.split(',').length - 1;
                
                return (commaCount < 3);
            }
        },
        methods: {
        },
        mounted() {
        },
        created() {

        }
    }
</script>

<style scoped>
</style>